import React, { useEffect, useState } from 'react';
import { Form, Checkbox ,message} from 'antd';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL } from '../Components/Constant'; // Ensure this path is correct

const EntryCriteria = ({
  availableFields,
  entryCriteria,
  setEntryCriteria,
  setLogicForEntryCriteria,
  logicForEntryCriteria,
  setValueOperatorEntry,
  valueOperatorEntry,
}) => {
  const [isChecked, setIsChecked] = useState(
    Array.isArray(entryCriteria) && entryCriteria.length > 0
  );
    const [lookupOptions, setLookupOptions] = useState([]); // For storing lookup options
  
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    setEntryCriteria(([{ 1: { field: '', value: '', displayValue: '' } }]));
  };

  const fetchLookupRecordsForExistingFilters = (existingFilters) => {
    existingFilters.forEach(filter => {
      const selectedField = availableFields.find(field => field.name === filter.field?.replace('_id', ''));
      if (selectedField && selectedField.type === 'lookup') {
        fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
      }
    });
  };


  const fetchLookupRecords = async (objectName) => {
    console.log('Fetching lookup records for:', objectName);
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response?.records?.map(record => ({
        value: record._id, // Set _id as value
        label: record.Name, // Set Name as label
      }));
      setLookupOptions(records); // Set options for the lookup field
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    }
  };
  // useEffect(() => {
  //   // setIsChecked()
  //   console.log('entrycriteira is ',entryCriteria);
  // }, entryCriteria);

  return (
    <>
      <Form.Item label="">
        <Checkbox
        checked={isChecked}
        onChange={handleCheckboxChange}
        >
          Add Entry Criteria
        </Checkbox>
      </Form.Item>
      <Form.Item name="entryCriteria" initialValue={entryCriteria}>

      {isChecked && (
        <FiltersDynamic
          fields={availableFields}
          logic={logicForEntryCriteria}
          setLogic={setLogicForEntryCriteria}
          filters={entryCriteria}
          setFilters={setEntryCriteria}
          setValueOperator={setValueOperatorEntry}
          valueOperator={valueOperatorEntry}
          fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
          fetchLookupRecords={fetchLookupRecords}
          lookupOptions={lookupOptions}
          heading="Entry Criteria Filters"
        />
      )}
      </Form.Item>

    </>
  );
};

export default EntryCriteria;
